export const summary = [
  'id',
  'name',
  'roles',
  'searchFilters',
  'moveInDate',
  'moveInDateUpdatedDate',
  'lastVisitDate',
  'signupProvider',
  'signupUtmSource',
  'phone',
  'phoneConfirmed',
  'phoneVerified',
  'settings',
  'frontTags',
  'leaseTerm',
  'leaseSituation',
  'experimentActiveVariants',
  'email',
  'secondaryPhone',
  'agentProfileImageHack',
  'createdDate',
  'leadType',
  'sessionCount',
  'frontTeammateId',
  'profilePicture',
  'shouldRefreshRoles',
  'stripeCustomerId',
  'landlordId',
  'partnerAppInstalled',
];

export const apartmentLocator = [
  ...summary,
  'apartmentLeadsSwitchDisabled',
  'apartmentLeadsEnabled',
  'apartmentLocatorSlackChannel',
  'apartmentLocatorFrontChannelId',
  'apartmentLocatorFrontInboxId',
  'apartmentLocatorAutoTextTemplate',
  'apartmentLocatorAutoTextTemplateTwo',
  'apartmentLocatorAutoTextTemplateThree',
  'apartmentLocatorAutoTextTemplateFour',
  'apartmentLocatorAutoTextTemplateFive',
  'apartmentLocatorAutoTextEnabled',
  'apartmentLocatorSignupEmailTemplateId',
  'frontTeammateId',
  'staffMarketId',
];

export const buyerSideAgentSummary = [
  ...summary,
  'agentMlsNumber',
];

export const agentLeadSummary = [
  ...summary,
  'startTouring',
];

export const login = [
  'id',
  'password',
];

export const teaser = [
  'id',
  'name',
  'phone',
  'staffMarketId',
  'householdAdminRoundRobinDisabled',
];

export const accountManager = [
  'id',
  'name',
  'phone',
  'email',
  'profileImage',
  'slackUserId',
];

export default {
  summary,
  apartmentLocator,
  login,
  teaser,
  accountManager,
  buyerSideAgentSummary,
};
